import { Component } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';
import { ClockService } from 'src/app/shared/services/clock.service';

@Component({
  selector: 'app-ong-hero',
  templateUrl: './ong-hero.component.html',
  styleUrls: ['./ong-hero.component.scss']
})
export class OngHeroComponent {
  now: Date = new Date();
  date: Date = new Date();

  constructor(private clockService: ClockService){
    this.clockService.getClock()
    this.clockService.localClock.subscribe(res=>{
      if(res) this.date = new Timestamp(res.data.seconds, res.data.nanoseconds).toDate()
    });
  }

}
